























































































































































































































































































































































































































































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";

@Component({
  components: {
    draggable,
  },
})
export default class extends AbpBase {
  @Prop() eleItem: any;
  // 批量添加弹框
  addMultipleStatus = false;
  eleItemValueData = "";

  // 删除选项
  removeEleItemValueData(index) {
    this.eleItem.valueData.splice(index, 1);
  }

  // 添加选项
  addEleItemValueData() {
    // 随机生成4位数防止报key重复错误
    let random = Math.floor(Math.random() * 9999);
    this.eleItem.valueData.push({
      value: "新选项" + random,
      label: "新选项" + random,
    });
  }

  // 弹出批量添加选项框方法
  addMultipleValueData() {
    this.addMultipleStatus = true;
    this.eleItemValueData = "";
  }

  // 确认批量添加选项方法
  saveAddMultiple() {
    if (!this.eleItemValueData) {
      this.$message({
        message: "请输入内容",
        type: "warning",
      });
      return;
    }
    let reg = /(\s*)(.+)(\s*)/g;
    let values = [];
    this.eleItemValueData.replace(reg, (...args) => {
      values.push(args[2]);
      return args[2];
    });
    values = [...new Set(values)];
    values.forEach((item) => {
      this.eleItem.valueData.push({
        value: item,
        label: item,
      });
    });
    this.addMultipleStatus = false;
  }

  // 改变日期选择器的类型触发
  changeDateType(e) {
    this.eleItem.valueFormat =
      e === "datetime" ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd";
  }

    // 改变日期选择器的类型触发
   changeDateType1(e) {
    this.eleItem.valueFormat =
      e === "DateTimePicker" ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD";
  }

  // 改变文字颜色是实时改变页面中的文字颜色
  changeTextColor(e) {
    this.eleItem.color = e;
  }

  @Watch("eleItem")
  handleEleItemChange(data) {
    // 不需要展示标题的组件集合
    let noShowNameData = ["text", "divider"];
    if (noShowNameData.some((item) => item === data.type)) {
      data.name = "";
    }
    this.$emit("update:eleItem", data);
  }

  handleColRemove(index) {
    this.eleItem.columns.splice(index, 1);
  }

  handleColAdd() {
    const key = `${new Date().getTime()}_${Math.ceil(Math.random() * 99999)}`;
    this.eleItem.columns.push({
      type: "col",
      key: key,
      parentKey: this.eleItem.key,
      span: 12,
      list: [],
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formBuilder/widgetConfig.vue